const state = {
    analyticsInitialized: false
  }
  
  const mutations = {
    SET_ANALYTICS_INITIALIZED(state, value) {
      state.analyticsInitialized = value
    }
  }
  
  const actions = {
    initializeAnalytics({ commit, rootState }) {
      // Use the apiUrl from the existing settings
      const apiUrl = rootState.settings.apiUrl
      
      if (window.gtag && !state.analyticsInitialized) {
        window.gtag('config', 'G-QTYQ7961QF', {
          custom_map: {
            'dimension1': 'parent_url'
          },
          parent_url: apiUrl
        })
        commit('SET_ANALYTICS_INITIALIZED', true)
      }
    },
  
    trackEvent({ rootState }, { eventName, params = {}, userEmail = null }) {
      if (window.gtag) {
        const eventParams = {
          ...params,
          parent_url: rootState.settings.apiUrl
        }
        
        if (userEmail) {
          eventParams.user_email = userEmail
        }
  
        window.gtag('event', eventName, eventParams)
      }
    },
  
    trackPage({ rootState }, { pageUrl, userEmail = null }) {
      if (window.gtag) {
        const configParams = {
          page_path: pageUrl,
          parent_url: rootState.settings.apiUrl
        }
  
        if (userEmail) {
          configParams.user_email = userEmail
        }
  
        window.gtag('config', 'G-QTYQ7961QF', configParams)
      }
    }
  }
  
  const getters = {
    isAnalyticsInitialized: state => state.analyticsInitialized
  }
  
  export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
  }